import React from 'react';
import type { Task } from '../../../store/ModalStore';
import styles from './CheckSubscriptionButton.module.css';
const CheckSubscriptionButton = ({
  onClick,
  isLocked,
  completed,
  task,
}: {
  onClick: () => void;
  isLocked: boolean;
  completed: boolean;
  task: Task;
}) => {
  return (
    <button
      className={styles.checkSubscriptionButton}
      onClick={onClick}
      disabled={isLocked}
    >
      Проверить подписку
    </button>
  );
};

export default CheckSubscriptionButton;
